// hook fetch to get request info in the response object, like axios to post process and retry apis
const globalAny: any = global;

interface PostProcessor {
	( input: RequestInfo, init?: RequestInit ): void;
}


declare global {
	interface RequestInit {
		postProcess?: PostProcessor;
		isRetry?: boolean;
	}

	interface RequestData {
		url: string;
		input: RequestInfo;
		init?: RequestInit;
	}

	interface Response {
		request?: RequestData;
	}
}


const hookedFetch = function ( input: RequestInfo, init?: RequestInit ): Promise<Response> {
	if ( typeof init?.postProcess === "function" ) {
		init?.postProcess( input, init );
	}
	return globalAny._fetch( input, init ).then( ( response: Response ) => {
		if ( response ) {
			const url = typeof input === "string" ? input : input.url;
			response.request = {
				url: url,
				input: input, init: init,
			};
		}
		return response;
	} );
};
if ( globalAny.fetch.hooked == null && process.env.NODE_ENV !== "test" ) {
	globalAny._fetch = fetch;
	globalAny.fetch = hookedFetch;
	globalAny.fetch.hooked = true;
}

export default {};
